import U from '../js/utils';

export default async ({totalPages, wrapperID}) => {
  return new Promise(async (resolve, reject) => {
    try {
      const paginationWrapper = U.id(wrapperID);
      paginationWrapper.innerHTML = '';
      // Set how much pagination buttons a user can see at a given time;
      const buttonWindowSize = 10;

      // Dictating the page number buttons that should be shown on the left and right of the button window
      let maxStartWindow = thsPage.vars.selected_page - Math.floor(buttonWindowSize / 2);
      let maxEndWindow = thsPage.vars.selected_page + Math.floor(buttonWindowSize / 2);

      // Making sure the pagination buttons don't go lower than page 1 or higher than the last page of data
      if (maxStartWindow < 1) {
        maxStartWindow = 1;
        maxEndWindow = buttonWindowSize;
      }
      if (maxEndWindow > totalPages) {
        maxStartWindow = totalPages - (buttonWindowSize - 1);
        maxEndWindow = totalPages;
        if (maxStartWindow < 1) {
          maxStartWindow = 1;
        }
      }

      for (let page = maxStartWindow; page <= maxEndWindow; page++) {
        paginationWrapper.innerHTML += `<button value=${page} class="pageButton mx-1 py-2 px-4">${page}</button>`;
      }
      if (thsPage.vars.selected_page != 1) {
        paginationWrapper.innerHTML = `<button value=${1} class="pageButton mx-1 py-2 px-4">First</button>` + paginationWrapper.innerHTML;
      }
      if (thsPage.vars.selected_page != totalPages) {
        paginationWrapper.innerHTML += `<button value=${totalPages} class="pageButton mx-1 py-2 px-4">Last</button>`;
      }

      resolve(paginationWrapper);
    } catch (error) {
      reject(error);
    }
  });
};
